export const ANALYTICS_CHUNK = 'Analytics';
